const decodeBase64Url = (value) => {
  const normalized = value.replace(/-/g, '+').replace(/_/g, '/');
  const padded = normalized.padEnd(Math.ceil(normalized.length / 4) * 4, '=');

  if (typeof atob === 'function') {
    const binaryString = atob(padded);
    const encoded = Array.from(binaryString, (character) => `%${character.charCodeAt(0).toString(16).padStart(2, '0')}`).join('');
    return decodeURIComponent(encoded);
  }

  if (typeof Buffer !== 'undefined') {
    return Buffer.from(padded, 'base64').toString('utf8');
  }

  throw new Error('No base64 decoder available');
};

export const decodeJwtPayload = (token) => {
  if (!token || typeof token !== 'string') {
    return null;
  }

  const parts = token.split('.');
  if (parts.length < 2) {
    return null;
  }

  try {
    return JSON.parse(decodeBase64Url(parts[1]));
  } catch (error) {
    return null;
  }
};

export const normalizeAuthUser = (user = {}, tokenPayload = null) => {
  const username = user.username
    || user.userName
    || tokenPayload?.username
    || tokenPayload?.preferred_username
    || tokenPayload?.user_name
    || tokenPayload?.email
    || tokenPayload?.sub
    || '';

  const displayName = user.displayName
    || [user.firstName, user.lastName].filter(Boolean).join(' ')
    || tokenPayload?.name
    || [tokenPayload?.given_name, tokenPayload?.family_name].filter(Boolean).join(' ')
    || user.firstName
    || username
    || 'User';

  return {
    ...user,
    id: user.id ?? tokenPayload?.id ?? tokenPayload?.user_id ?? tokenPayload?.sub ?? null,
    username,
    displayName,
    firstName: user.firstName || tokenPayload?.given_name || displayName,
    lastName: user.lastName || tokenPayload?.family_name || '',
  };
};
